<template>
  <div>
    <div style="max-width: 86%">
      <v-alert
        text
        type="error"
        icon="mdi-cloud-alert"
        :value="ciemException.error != null"
      >
        {{ ciemException.error }}
      </v-alert>
      <v-alert
        text
        outlined
        color="deep-orange"
        icon="mdi-fire"
        :value="ciemException.warning != null"
      >
        {{ ciemException.warning }}
      </v-alert>
      <v-alert
        text
        dense
        color="teal"
        icon="mdi-clock-fast"
        border="left"
        :value="ciemException.success != null"
      >
        {{ ciemException.success }}
      </v-alert>
    </div>
    <crud-detail
      :update-mode="updateMode"
      :showButton="false"
      class="mt-2"
      :next="next"
      :modalLeave="modalLeave"
      @closeLeave="modalLeave = false"
    >
      <v-layout row>
        <v-flex md12 ml-2>
          <v-btn
            v-if="
              actif &&
              updateMode &&
              roleCorrespondant &&
              form.demandeMutationEnCours != true
            "
            style="min-width: 14.85em"
            dark
            color="blue"
            class="px-3 white--text custom-radiation mr-5 mt-3"
            @click="beforeMuter()"
            :loading="saving"
          >
            {{ $t('participant.muter.action') }}
          </v-btn>

          <v-btn
            @click="resiliationPopup = true"
            color="pink"
            dark
            class="custom-radiation px-3 mr-5 mt-3"
            v-if="updateMode && actif && roleCorrespondant"
            style="min-width: 14.85em"
          >
            {{ $t('participant.resilier') }}
          </v-btn>

          <v-btn
            v-if="!actif && updateMode && roleCorrespondant"
            color="green"
            class="px-3 white--text custom-radiation mr-5 mt-3"
            @click="readhesion"
            :loading="saving"
            style="min-width: 14.85em"
          >
            {{ $t('participant.readherer') }}
          </v-btn>

          <v-btn
            v-if="actif"
            dark
            :class="
              'custom-save white--text px-3 mr-5 mt-3' +
              (!actif ? ' disabled' : 'mr-5 mt-3')
            "
            @click="customSave"
            color="primary"
            :disabled="!actif"
            :loading="saving"
            style="min-width: 14.85em"
          >
            {{ $t(updateMode ? 'button.save' : 'button.create') }}
          </v-btn>
        </v-flex>
        <!-- Début Dialog Portable incorrect -->
        <v-dialog v-model="dialogPortable" width="500px">
          <v-card>
            <v-toolbar card dark color="orange">
              <v-toolbar-title>
                {{ $t('participant.attention') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert :value="true" color="info" icon="info">
                {{ $t('participant.alertContact') }}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="dialogPortable = false"> OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTypeBilan" width="500px">
          <v-card>
            <v-toolbar card dark color="orange">
              <v-toolbar-title>
                {{ $t('participant.attention') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert :value="true" color="info" icon="info">
                {{ $t('participant.alertTypeBilan') }}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="dialogTypeBilan = false"> OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Fin Dialog avertissement-->
      </v-layout>
      <v-layout row class="specific">
        <v-flex md2 mb-5 ml-2>
          <v-chip :color="status.color" text-color="white">
            <v-avatar>
              <v-icon>{{ status.icon }}</v-icon>
            </v-avatar>
            {{ status.label }}
          </v-chip>
        </v-flex>
        <v-flex md3 mb-5 v-if="form.demandeMutationEnCours == true">
          <v-chip color="pink" text-color="white">
            Demande de mutation en cours
          </v-chip>
        </v-flex>
        <v-flex md2 mb-5 v-if="form.bilanEnCours == true">
          <v-chip color="pink" text-color="white">
            {{ $t('participant.bilanEnCours') }}
          </v-chip>
        </v-flex>
      </v-layout>

      <v-layout
        row
        :class="!actif ? ' pr-2 pl-2 pt-3 radie' : 'pr-2 pl-2 pt-3'"
      >
        <!-- informations participant (gauche) -->

        <v-flex md4>
          <v-layout row mt-2>
            <v-flex md6 class="classShowOff">
              <v-text-field
                :value="id || $t('participant.details.afterCreation')"
                :label="$t('participant.details.id')"
                readonly
                disabled
              />
            </v-flex>
            <v-flex md6>
              <enum-entity-field
                namespace="civilite"
                :additionalField="Array.from(['raccourci'])"
                v-model="form.civilite"
                i18n="participant.details.civilite"
                :disabled="!actif"
                :validation="$v.form.civilite"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6 :class="createMode ? '' : 'classShowOff'">
              <v-text-field
                v-model="form.nom"
                :readonly="!createMode"
                :disabled="!createMode"
                :label="$t('participant.details.nom')"
                autocomplete="new-password"
                :error-messages="$errors($v.form.nom)"
              />
            </v-flex>
            <v-flex md4 :class="createMode ? '' : 'classShowOff'">
              <v-text-field
                v-model="form.prenom"
                :readonly="!createMode"
                :disabled="!createMode"
                :label="$t('participant.details.prenom')"
                autocomplete="new-password"
                :error-messages="$errors($v.form.prenom)"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <v-text-field
                v-model="form.nomPhonetique"
                :label="$t('participant.details.nomPhonetique')"
                :disabled="!actif"
              />
            </v-flex>
            <v-flex :class="createMode ? '' : 'classShowOff'">
              <v-text-field
                v-model="form.nomJeuneFille"
                :disabled="!actif"
                :label="$t('participant.details.nomJeuneFille')"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6 :class="createMode ? '' : 'classShowOff'">
              <date-picker
                :label="$t('participant.details.dateDeNaissance')"
                v-model="form.dateDeNaissance"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                :readonly="!createMode"
                :disabled="!createMode"
                :max="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
                :validator="$v.form.dateDeNaissance"
              />
            </v-flex>
            <v-flex md6>
              <enum-entity-field
                namespace="genre"
                v-model="form.genre"
                :additionalField="Array.from(['raccourci'])"
                i18n="participant.details.genre.label"
                :validation="$v.form.genre"
                :disabled="!actif"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12>
              <enum-entity-field
                namespace="profession"
                :additionalField="Array.from(['raccourci'])"
                v-model="form.profession"
                i18n="participant.details.profession"
                :disabled="!actif"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md5>
              <enum-entity-field
                namespace="pays"
                :additionalField="Array.from(['unionEuropeenne', 'raccourci'])"
                v-model="form.paysExercice"
                i18n="participant.details.pays"
                :validation="$v.form.paysExercice"
                :disabled="!actif"
              />
            </v-flex>
            <v-flex md1>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="teal" size="21" v-bind="attrs" v-on="on">
                    <span class="white--text">?</span>
                  </v-avatar>
                </template>
                {{ $t('participant.details.informationPaysExercice') }}
              </v-tooltip>
            </v-flex>
            <v-flex md6>
              <enum-entity-field
                namespace="provenance"
                v-model="form.provenance"
                :additionalField="Array.from(['raccourci'])"
                i18n="participant.details.provenance"
                :validation="$v.form.provenance"
                :disabled="!actif"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <!-- <v-flex md6 v-if="" class="classShowOff">
              <enum-entity-field
                namespace="categorie"
                :additionalField="Array.from(['raccourci'])"
                v-model="form.categorie"
                i18n="participant.details.categorie"
                disabled
              />
            </v-flex>-->
            <v-flex
              md4
              v-if="form.categorie && form.categorie.raccourci == 'SAL'"
              class="classShowOff"
            >
              <v-text-field
                :label="$t('participant.details.etablissementId')"
                :value="form.etablissement ? form.etablissement.id : ''"
                readonly
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex
              md8
              v-if="form.categorie && form.categorie.raccourci == 'SAL'"
              class="classShowOff"
            >
              <v-text-field
                :label="$t('participant.details.etablissementRaisonSociale')"
                :value="
                  form.etablissement ? form.etablissement.raisonsociale : ''
                "
                readonly
                disabled
                class="red--text"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-combobox
                v-model="form.typeBilan"
                :items="
                  !roleCorrespondant
                    ? enums.typeBilan
                    : getTypesBilanCorrespondant()
                "
                item-text="label"
                item-value="id"
                :append-icon="''"
                :error-messages="
                  $v.form.typeBilan ? $errors($v.form.typeBilan) : []
                "
                :label="$t('participant.details.typeBilan')"
                :readonly="
                  !createMode && (!roleCorrespondant || form.bilanEnCours)
                "
                :disabled="
                  !createMode && (!roleCorrespondant || form.bilanEnCours)
                "
                @mousedown="
                  roleCorrespondant && form.bilanEnCours
                    ? (dialogTypeBilan = true)
                    : ''
                "
              />
            </v-flex>
            <v-flex md6>
              <date-picker
                v-model="form.dateProchainBilan"
                :label="$t('participant.details.dateProchainBilan')"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                :min="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
                :validator="$v.form.dateProchainBilan"
                :readonly="!createMode"
                :disabled="!createMode"
              />
            </v-flex>
          </v-layout>
          <v-layout row class="mt-2">
            <v-flex md6>
              <enum-entity-field
                namespace="GESTIONRDV"
                v-model="form.gesRDV"
                :additionalField="Array.from(['raccourci'])"
                i18n="participant.details.gesRDV"
                :validation="$v.form.gesRDV"
                readonly
                :disabled="!createMode"
              />
            </v-flex>
            <v-flex md5>
              <enum-entity-field
                namespace="periodicitebilan"
                v-model="form.periodiciteBilan"
                :additionalField="Array.from(['raccourci'])"
                i18n="participant.details.periodiciteBilan"
                :validation="$v.form.periodiciteBilan"
                :readonly="!createMode"
                :disabled="!createMode"
              />
            </v-flex>
            <v-flex
              md1
              :style="{
                display:
                  etablissement.periodiciteBilanCommentaire.lignes.length > 0
                    ? ''
                    : 'none',
              }"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="teal" size="21" v-bind="attrs" v-on="on">
                    <span class="white--text">?</span>
                  </v-avatar>
                </template>
                <ul>
                  <li
                    v-for="(ligne, key) in etablissement
                      .periodiciteBilanCommentaire.lignes"
                    :key="key"
                  >
                    <div>
                      {{ ligne.auteurCreation.name + ' '
                      }}<span v-html="ligne.texte"></span>
                    </div>
                  </li>
                </ul>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-text-field
                v-model="form.info4"
                :label="$t('participant.details.info4')"
                disabled
                readonly
              />
            </v-flex>
          </v-layout>
          <v-layout row mt-5 mb-5 v-if="updateMode">
            <v-flex>
              <v-card class="specific mx-auto" color="primary" outlined>
                <v-card-title
                  etablissementsEntrepriseInsee
                  :class="!actif ? ' radie black--text ' : 'white--text'"
                >
                  <v-flex style="max-width: 700px">
                    <v-icon dark>mdi-library</v-icon>&nbsp;&nbsp;
                    <p
                      v-html="
                        $t('participant.details.gestionnaire.message', [
                          (gestionnaire.standard == true ? ' Le ' : ' ') +
                            gestionnaire.name,
                          gestionnaire.telephone,
                          gestionnaire.email,
                        ])
                      "
                    ></p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex md7 ml-5>
          <v-layout row>
            <v-flex md3 mt-2>
              <date-picker
                :label="$t('participant.details.dateAdhesion')"
                v-model="form.dateAdhesion"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                readonly
                :max="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
              />
            </v-flex>
            <v-flex md3 mt-2>
              <date-picker
                :label="$t('participant.details.datePremiereAdhesion')"
                v-model="form.datePremiereAdhesion"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                readonly
                :max="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
              />
            </v-flex>
            <v-flex md3 mt-2>
              <date-picker
                :label="$t('participant.details.dateResiliation')"
                v-model="form.dateResiliation"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                readonly
                :max="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12>
              <v-card class="specific">
                <v-card-title :class="!actif ? ' radie' : 'info white--text'">
                  <v-icon dark>mdi-home-account</v-icon>&nbsp;&nbsp;
                  <span style="margin-left: 5px">{{
                    $t('participant.details.adresse')
                  }}</span>
                </v-card-title>
                <v-layout row class="ma-2 pa-1">
                  <v-flex md12>
                    <v-row v-if="form.etablissement">
                      <v-col md="5">
                        <v-checkbox
                          v-model="form.adresseEtablissement"
                          :label="
                            $t(
                              'participant.details.utiliserAdresseEtablissement',
                            )
                          "
                          color="primary"
                        />
                      </v-col>
                    </v-row>
                    <v-layout row>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.ligne1"
                          :label="$t('adresse.ligne1.particulier.label')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.ligne2"
                          :label="$t('adresse.ligne2.particulier.label')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.ligne3"
                          :label="$t('adresse.ligne3.label')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md1>
                        <v-text-field
                          v-model="currentAdresse.numeroVoie"
                          :label="$t('adresse.numeroVoie')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                      <v-flex md3>
                        <enum-entity-field
                          namespace="typevoie"
                          :additionalField="Array.from(['raccourci'])"
                          v-model="currentAdresse.typeVoie"
                          i18n="adresse.typeVoie"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.nomVoie"
                          :label="$t('adresse.nomVoie')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.ligne5"
                          :label="$t('adresse.ligne5.label')"
                          :disabled="!actif || form.adresseEtablissement"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md4>
                        <v-text-field
                          v-model="currentAdresse.codePostal"
                          :label="$t('adresse.codePostal')"
                          :disabled="!actif || form.adresseEtablissement"
                          :error-messages="
                            $errors($v.currentAdresse.codePostal)
                          "
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-combobox
                          :value="currentAdresse.localite"
                          :items="communesPossibles"
                          :search-input.sync="localLocalite"
                          :label="$t('adresse.localite.particulier')"
                          :menu-props="{ value: localiteVisible }"
                          :disabled="!actif || form.adresseEtablissement"
                          @focus="localiteVisible = true"
                          @click="localiteVisible = true"
                          @blur="localiteVisible = false"
                          @input="
                            localiteVisible = false
                            form.adresse.localite = $event
                          "
                          :no-data-text="$t('noDataText')"
                        ></v-combobox>
                      </v-flex>
                      <v-flex md4>
                        <enum-entity-field
                          namespace="pays"
                          v-model="currentAdresse.pays"
                          :additionalField="
                            Array.from(['unionEuropeenne', 'raccourci'])
                          "
                          i18n="adresse.pays"
                          sortBy="label"
                          :disabled="!actif || form.adresseEtablissement"
                          :validation="$v.currentAdresse.pays"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md12>
              <v-card class="specific">
                <v-card-title :class="!actif ? ' radie' : 'info white--text'">
                  <v-icon dark>mdi-card-account-mail</v-icon>&nbsp;&nbsp;
                  <span style="margin-left: 5px">
                    {{ $t('participant.details.coordonnee') }}</span
                  >
                </v-card-title>
                <v-layout row class="ma-2 pa-1">
                  <v-flex md12>
                    <v-layout row>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.telFixe"
                          :label="$t('participant.details.telFixe')"
                          :disabled="!actif"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.telPortable"
                          :label="$t('participant.details.telPortable')"
                          :disabled="!actif"
                          autocomplete="new-password"
                          :error-messages="$errors($v.form.telPortable)"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.mail"
                          :label="$t('participant.details.mail')"
                          :disabled="!actif"
                          autocomplete="new-password"
                          :error-messages="$errors($v.form.mail)"
                        />
                      </v-flex>

                      <v-flex md3>
                        <v-text-field
                          v-model="form.telSecretariat"
                          :label="$t('participant.details.telSecretariat')"
                          :disabled="!actif"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12>
              <v-card class="specific">
                <v-card-title :class="!actif ? ' radie' : 'info white--text'">
                  <v-icon dark>mdi-contacts</v-icon>&nbsp;&nbsp;
                  <span style="margin-left: 5px">
                    {{ $t('participant.details.contact') }}
                  </span>
                </v-card-title>
                <v-layout row class="ma-2 pa-1">
                  <v-flex md12>
                    <v-layout row>
                      <v-flex md3>
                        <enum-entity-field
                          namespace="civilite"
                          :additionalField="Array.from(['raccourci'])"
                          v-model="form.contact.civilite"
                          i18n="participant.details.civilite"
                          :disabled="!actif"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.contact.nom"
                          :disabled="!actif"
                          :label="$t('participant.details.nom')"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.contact.prenom"
                          :disabled="!actif"
                          :label="$t('participant.details.prenom')"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.contact.mail"
                          :disabled="!actif"
                          :label="$t('participant.details.mail')"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.contact.telFixe"
                          :disabled="!actif"
                          :label="$t('participant.details.telFixe')"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          v-model="form.contact.telPortable"
                          :disabled="!actif"
                          :label="$t('participant.details.telPortable')"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.contact.fonction"
                          :disabled="!actif"
                          :label="$t('participant.details.fonction')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </crud-detail>
    <c-dialog
      persistent
      :dialog="resiliationPopup"
      max-width="50%"
      @close="resiliationPopup = false"
    >
      <confirmation-resiliation
        @resilier="resilier"
        v-model="resiliationMotif"
        @close="resiliationPopup = false"
      />
    </c-dialog>

    <c-dialog
      persistent
      :dialog="muterPopup"
      max-width="50%"
      @close="muterPopup = false"
    >
      <muter-popup
        :etablissementDestination="etablissementDestination"
        @close="muterPopup = false"
        @muter="muter"
        :etablissementsEntrepriseInsee="etablissementsEntrepriseInsee"
        :visible="muterPopup"
        :bilanEnCours="form.bilanEnCours"
      />
    </c-dialog>
  </div>
</template>

<script>
import Datasource from '@/utils/datasource'
import DetailCrud from '@/plugins/DetailCrud'
import moment from 'moment'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import _ from 'lodash'
import { alert } from '@/commun/alertMessage'
import Api from '@/utils/api'
import { formatDate } from '@/utils/date'
import toasted from '@/utils/toasted'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import { accents } from '@/utils/string'
import { provenanceValidator } from '@/utils/validators'

const NAMESPACE = 'adherents'
const ParisProvenance = ['75', '77', '78', '91', '92', '93', '94', '95']

export default {
  mixins: [DetailCrud, DateFormatter],
  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    }
  },
  data() {
    const etablissementsEntrepriseInsee = new Datasource(
      'etablissementsEntrepriseInsee',
      {
        sortBy: 'id',
      },
    )
    return {
      namespace: NAMESPACE,
      ciemException: alert,
      resiliationPopup: false,
      resiliationMotif: null,
      muterPopup: false,
      etablissementDestination: {
        etablissementSource: null,
        etablissementRemplacant: null,
        priseEnChargeBilanEnCours: false,
      },
      etablissementsEntrepriseInsee,
      form: {
        adresse: {},
        contact: {},
        telPortable: null,
        provenance: {
          id: null,
          label: '',
        },
        gesRDV: {
          id: 1221,
          label: "A l'initiative du CIEM",
          labelCourt: 'ACIEM',
          actif: true,
          raccourci: 'ACIEM',
        },
        adresseEtablissement: false,
      },
      dialogPortable: false,
      dialogTypeBilan: false,
      gestionnaire: {},
      communesPossibles: [],
      localiteVisible: false,
      localLocalite: '', // permet de saisir ce qu'on veut dans le combobox
      etablissement: {
        periodiciteBilanCommentaire: {
          lignes: [],
        },
      },
      enums: {
        typeBilan: [],
      },
      currentAdresse: {},
    }
  },
  beforeCreate() {
    new Api('abstractenum/typeBilan')
      .get()
      .then((response) => {
        if (response && response.body) {
          this.enums.typeBilan = response.body.items
        }
      })
      .catch((error) => {
        try {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.typeBilan')
          }
        } catch (err) {
          console.log('')
        }
      })
  },
  created() {},
  beforeMount() {
    if (this.$route.params.id != 'new') {
      let uri = ''
      if (this.$route.name == 'adherentsCorrespondant/detail') {
        uri = this.$route.name + '/' + this.$route.params.id
      } else if (this.$route.name == '/mescoordonnees') {
        uri = 'participant' + this.$route.name
      } else if (this.$route.name == 'adherents') {
        uri = this.$route.name + '/' + this.$route.params.id
      }

      new Api(uri)
        .get()
        .then((response) => {
          this.initForm(response.body)
          this.setInitialFormDigest()
        })
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
    }
    if (this.$route.params.id != 'new' && this.$route.name == 'adherentsCorrespondant/detail') {
      new Api('etablissement-participant/' + this.$route.params.id)
        .get()
        .then((response) => {
          this.etablissement = response.body
          if (this.createMode) {
            this.form.gesRDV = response.body.gestionRdv
            this.form.periodiciteBilan = response.body.periodiciteBilan
          }
          this.setInitialFormDigest()
        })
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.createMode) {
        this.form.dateAdhesion = formatDate(new Date())
        this.form.datePremiereAdhesion = formatDate(new Date())

        this.$v.form.$touch()
      }
      this.$on('createCatchException', this.errorHandler)
      this.$on('updateCatchException', this.errorHandler)
    })
  },
  beforeDestroy() {
    this.resetAlert()
  },
  computed: {
    status() {
      return {
        icon: this.form.actif === true ? 'check_circle' : 'highlight_off',
        label:
          this.form.actif === true
            ? this.$t('participant.details.status.actif')
            : this.$t('participant.details.status.inactif'),
        color: this.form.actif === true ? 'teal' : 'red',
      }
    },
    actif() {
      return !this.updateMode ? true : this.form.actif
    },
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
  },
  watch: {
    'form.paysExercice'(val) {
      if (
        (val && val.id != 716) ||
        (this.form.adresse &&
          this.form.adresse.pays &&
          this.form.adresse.pays.id != 716)
      ) {
        this.form.provenance = { id: 18, label: 'ETRANGER' }
        this.setInitialFormDigest()
      } else if (
        (!this.form.provenance || this.form.provenance.id == 18) &&
        (val == null || val.id == 716)
      ) {
        this.form.provenance = this.calculProvenanceEnFonctionAdresse(
          this.form.adresse,
        )
        this.setInitialFormDigest()
      }
    },
    'form.adresse': {
      handler(val) {
        //if (!this.form.provenance) {
        if (
          (val && val.pays && val.pays.id != 716) ||
          (this.form.paysExercice && this.form.paysExercice.id != 716)
        ) {
          this.form.provenance = {
            id: 18,
            label: 'ETRANGER',
          }
          this.setInitialFormDigest()
        } else if (
          val &&
          (!this.form.provenance || this.form.provenance.id == 18) &&
          (this.form.paysExercice == null || this.form.paysExercice.id == 716)
        ) {
          this.form.provenance = this.calculProvenanceEnFonctionAdresse(val)
          this.setInitialFormDigest()
        }
        //}
      },
      deep: true,
    },
    'form.adresse.codePostal'(val) {
      this.searchCommunes(val).then((response) => {
        if (response) {
          this.localiteVisible = true
          this.form.adresse.pays = {
            id: 716,
            label: 'FRANCE',
            raccourci: '0033',
            unionEuropeenne: true,
          }
        }
      })
    },
    'form.nom'(newVal) {
      if (newVal != null) {
        this.form.nom = accents(newVal.toUpperCase())
      }
    },
    localLocalite(val) {
      this.form.adresse.localite = val
    },
    'form.adresseEtablissement'(val) {
      if (val) {
        this.currentAdresse = this.form.etablissement.adresse
      } else {
        this.currentAdresse = this.form.adresse
      }
    },
    currentAdresse(val) {
      if (!this.form.adresseEtablissement) {
        this.form.adresse = val
      }
    },
  },
  methods: {
    initForm(loaded) {
      if (loaded) {
        this.id = loaded.id
        this.form = loaded
        if (loaded.contact == null) {
          this.form.contact = {}
        }
        if (loaded.gestionnaire != null) {
          this.gestionnaire = loaded.gestionnaire
        } else {
          this.gestionnaire = {}
        }
        if (loaded.adresse == null) {
          this.form.adresse = {}
        } else {
          if (this.form.adresseEtablissement) {
            this.currentAdresse = this.form.etablissement.adresse
          } else {
            this.currentAdresse = this.form.adresse
          }
        }
      }
    },
    callEntity() {
      new Api(this.$route.name + '/' + this.$route.params.id)
        .get()
        .then((response) => {
          this.initForm(response.body)
          this.setInitialFormDigest()
        })
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    verifIfPortableCorrect(phoneNumber) {
      return this.$api('user/verifIfPortableCorrecte/' + phoneNumber)
        .get()
        .then((response) => {
          return response.body
        })
        .catch((message) => {
          if (message.error == 'access_denied') {
            toasted.error('auth.accessDenied')
          } else {
            toasted.error(
              'Une erreur technique a eu lieu pendant la vérification si le numéro de téléphone portable du participant est correct',
            )
          }
        })
    },
    customSave() {
      this.resetAlert()
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.verifIfPortableCorrect(this.form.telPortable).then(
          (portableCorrecte) => {
            if (!portableCorrecte) {
              this.dialogPortable = true
            } else if (!this.$v.form.$invalid) {
              if (this.createMode) {
                if (
                  !this.form.adresse.numeroVoie ||
                  !this.form.adresse.nomVoie ||
                  !this.form.adresse.codePostal ||
                  !this.form.adresse.localite
                ) {
                  this.form.adresse = this.etablissement.adresse
                }
                const api = this.$api(this.createURI)
                this.saving = true
                return api
                  .put(this.form)
                  .then((response) => {
                    const participantCree = response.body.participantcree
                    if (
                      response &&
                      response.body &&
                      response.body.ciemException &&
                      !_.isEmpty(response.body.ciemException.messages)
                    ) {
                      response.body.ciemException.messages.forEach((m) => {
                        if (m.level == 'ERROR') {
                          this.ciemException.error = this.$t(m.errorCode)
                        } else if (m.level == 'WARN') {
                          this.ciemException.warning = this.$t(m.errorCode)
                        } else if (m.level == 'INFO') {
                          this.ciemException.success = this.$t(m.errorCode)
                        }
                      })
                    }
                    if (participantCree == true) {
                      this.id = response.body.idParticipant
                      this.setInitialFormDigest()
                      this.refreshView()
                    }
                    //this.ciemException = response;
                    //this.refreshView();
                  })
                  .catch(() => {
                    toasted.error('api.error.500')
                  })
                  .finally(() => {
                    this.saving = false
                  })
              } else {
                const api = this.$api(this.createURI)
                //updateURI pour qu'un correspondant modifie un participant
                this.saving = true
                return api
                  .post(this.form)
                  .then((response) => {
                    if (
                      response &&
                      response.body &&
                      !_.isEmpty(response.body.messages)
                    ) {
                      response.body.messages.forEach((m) => {
                        if (m.level == 'ERROR') {
                          this.ciemException.error = this.$t(m.errorCode)
                        } else if (m.level == 'WARN') {
                          this.ciemException.warning = this.$t(m.errorCode)
                        } else if (m.level == 'INFO') {
                          this.ciemException.success = this.$t(m.errorCode)
                        }
                      })
                    }
                    //this.ciemException = response;
                    this.refreshView()
                  })
                  .catch(() => {
                    toasted.error('api.error.500')
                  })
                  .finally(() => {
                    this.saving = false
                  })
              }
            }
          },
        )
      }
    },
    resilier() {
      this.resetAlert()
      this.resiliationPopup = false
      if (this.updateMode) {
        this.saving = true

        const input = {
          motifMouvement: this.resiliationMotif,
        }

        this.$api(NAMESPACE + '/' + this.id + '/resilier')
          .post(input)
          .then((response) => {
            this.resiliationMotif = null
            this.form.status = 'Inactif'
            this.form.dateResiliation = formatDate(new Date())

            if (
              response &&
              response.body &&
              !_.isEmpty(response.body.messages)
            ) {
              response.body.messages.forEach((m) => {
                if (m.level == 'ERROR') {
                  this.ciemException.error = this.$t(m.errorCode)
                } else if (m.level == 'WARN') {
                  this.ciemException.warning = this.$t(m.errorCode)
                } else if (m.level == 'INFO') {
                  this.ciemException.success = this.$t(m.errorCode)
                }
              })
            }
            toasted.info('participant.resiliation.resilie')
            //this.ciemException = response;
            this.callEntity()
          })
          .catch(() => {})
          .finally(() => {
            this.saving = false
          })
      }
    },
    readhesion() {
      this.resetAlert()
      this.saving = true
      this.$api(this.updateURI + '/adherer')
        .post()
        .then(
          (response) => {
            if (
              response &&
              response.body &&
              !_.isEmpty(response.body.messages)
            ) {
              response.body.messages.forEach((m) => {
                if (m.level == 'ERROR') {
                  this.ciemException.error = this.$t(m.errorCode)
                } else if (m.level == 'WARN') {
                  this.ciemException.warning = this.$t(m.errorCode)
                } else if (m.level == 'INFO') {
                  this.ciemException.success = this.$t(m.errorCode)
                }
              })
            }
            //this.ciemException = response;
            this.callEntity()
          },
          (error) => toasted.error(error.message),
        )
        .catch(() => {})
        .finally(() => {
          this.saving = false
        })
    },
    beforeMuter() {
      // this.etablissementsEntrepriseInsee.args.idTechnique = this.$auth.idTechnique();
      this.etablissementsEntrepriseInsee.refresh()
      this.muterPopup = true
    },
    muter() {
      this.resetAlert()
      const input = {
        etablissementDestination:
          this.etablissementDestination.etablissementRemplacant.id,
        priseEnChargeBilanEnCours:
          this.etablissementDestination.priseEnChargeBilanEnCours,
      }
      this.saving = true
      this.$api(this.updateURI + '/muter')
        .post(input)
        .then(
          (response) => {
            if (
              response &&
              response.body &&
              !_.isEmpty(response.body.messages)
            ) {
              response.body.messages.forEach((m) => {
                if (m.level == 'ERROR') {
                  this.ciemException.error = this.$t(m.errorCode)
                } else if (m.level == 'WARN') {
                  this.ciemException.warning = this.$t(m.errorCode)
                } else if (m.level == 'INFO') {
                  this.ciemException.success = this.$t(m.errorCode)
                }
              })
            }
            //this.ciemException = response;
            this.callEntity()
          },
          (error) => toasted.error(error.message),
        )
        .catch(() => {})
        .finally(() => {
          this.saving = false
          this.muterPopup = false
        })
    },
    resetAlert() {
      this.ciemException.error = null
      this.ciemException.warning = null
      this.ciemException.success = null
    },
    calculProvenanceEnFonctionAdresse(adresse) {
      if (
        adresse &&
        ((adresse.pays && adresse.pays.id == 716) || adresse.pays == null) &&
        adresse.codePostal
      ) {
        let stratWith = adresse.codePostal.substring(0, 2)
        if (ParisProvenance.includes(stratWith)) {
          return { id: 17, label: 'Paris' }
        } else {
          return { id: 16, label: 'Province' }
        }
      }
    },
    searchCommunes(val) {
      if (val && val.length >= 5 && !this.form.adresse.localite) {
        return this.$api('adresse/code-postal')
          .get({ params: { codePostal: val } })
          .then((response) => {
            this.communesPossibles = response.body
            if (this.communesPossibles.length === 1) {
              this.form.adresse.localite = this.communesPossibles[0]
            }
            return true
          })
          .catch(() => {})
      }
      return Promise.resolve(false)
    },
    getTypesBilanCorrespondant() {
      const autorized = [
        'BILAN TRADITIONNEL ET DE GYNECOLOGIE',
        'BILAN TRADITIONNEL EXPATRIE ET DE GYNECOLOGIE',
        'BILAN TRADITIONNEL',
        'BILAN TRADITIONNEL EXPATRIE',
      ]
      return this.enums.typeBilan.filter((t) => autorized.indexOf(t.label) > -1)
    },
  },
  validations() {
    return {
      form: {
        nom: {
          required,
        },
        prenom: {
          required,
        },
        civilite: {
          required,
        },
        dateDeNaissance: {
          required,
        },
        genre: {
          required,
        },
        paysExercice: {
          required,
        },
        telPortable: {
          required,
        },
        mail: {
          required,
          email,
        },
        contact: {},
        provenance: {
          provenanceValidator: provenanceValidator(
            this.form.paysExercice,
            this.form.adresse,
          ),
        },
        typeBilan: {
          required,
        },
        dateProchainBilan: {
          required,
        },
        periodiciteBilan: {
          required,
        },
        adresse: {
          codePostal: {
            maxLength: maxLength(10),
          },
        },
      },
      currentAdresse: {
        codePostal: {
          maxLength: maxLength(10),
        },
        pays: { required },
      },
    }
  },
}
</script>

<style scoped>
.custom-save {
  border-radius: 5px;
}

.custom-delete {
  border-radius: 5px;
}

.custom-message {
  background-color: var(--v-primary-base);
}

.v-subheader {
  background-color: var(--v-updatedGrey-base);
  color: white !important;
  border-radius: 5px;
  font-size: 13px;
}

.subheaderSpecificColor .v-subheader {
  background-color: var(--v-rose-base) !important;
}

.v-subheader .v-icon {
  color: white;
}

.custom-yellow-badge >>> .v-badge__badge {
  background-color: var(--v-yellow-base) !important;
}
</style>
<style>
.specific table.v-table tbody td {
  font-size: 11px;
}

.specific .material-icons {
  font-size: 18px;
}
.specificTableau .v-messages {
  display: none;
}

.specificTableau .v-input__slot {
  margin-bottom: 0px !important;
}

.specific .v-system-bar--window {
  height: 23px !important;
}

.specific .v-subheader {
  height: 23px !important;
}

.specificCloseBtn .v-btn--floating.v-btn--small {
  height: 33px !important;
  min-width: 0;
  padding: 0;
  width: 33px !important;
}
.specific .v-chip .v-chip__content {
  height: 26px;
}
.smallChip .v-chip {
  font-size: 10px !important;
  height: 20px;
}
.smallChip .v-chip .v-avatar {
  height: 20px !important;
  min-width: 20px;
  width: 20px !important;
}

.specific .v-avatar {
  height: 28px !important;
  width: 28px !important;
}

.reduceDialogClass {
  top: 4.10417px !important;
  position: fixed !important;
  margin: 0px !important;
  transition: none 0s ease 0s !important;
}
</style>
